<template>
  <div class="loginbody loading-area" id="loginbody">
    <div class="loginbody-bg">
      <div class="logo-name">
        <!-- <p>韶关市武江区智慧停车管理平台</p> -->
        <p>{{ systemConfig.PLATFORM_NAME }}</p>
        <p>Intelligent parking management expert</p>
      </div>
      <form action="#" method="post" autocomplete="off">
        <div class="loginbox">
          <div class="input">
            <ul>
              <li class="logins">
                <input
                  type="text"
                  autofocus="autofocus"
                  class="loginuser"
                  id="username"
                  name="fake-username"
                  v-model="loginForm.username"
                  @focus="isFocus = true"
                  @blur="isFocus = false"
                  autocomplete="off"
                  v-noBlankSpace
                />
              </li>
              <li class="form_tip" id></li>
              <li class="logins loginpsd">
                <input
                  type="password"
                  class="loginpwd"
                  id="password"
                  name="fake-password"
                  v-model="loginForm.password"
                  @focus="isFocuspsd = true"
                  @blur="isFocuspsd = false"
                  autocomplete="new-password"
                  v-noBlankSpace
                />
              </li>
              <li class="form_tip" id></li>
              <li class="logins captcha-line">
                <input
                  type="text"
                  class="login-captcha"
                  v-model="loginForm.captcha"
                  placeholder="请输入验证码"
                  autocomplete="off"
                />
                <img
                  :src="captchaImg"
                  @click="refreshCaptcha"
                  style="vertical-align: middle; cursor: pointer; margin-left: 10px; height: 32px;"
                  title="点击刷新验证码"
                />
              </li>
              <li style="text-align: center">
                <button
                  type="button"
                  class="btnlogin"
                  id="login"
                  name="#"
                  @click="submitForm"
                  @keyup="handleKeydown($event)"
                >
                  登&nbsp;&nbsp;录
                </button>
              </li>
            </ul>
          </div>
        </div>
      </form>
    </div>
    <div class="beian">
      <a href="http://beian.miit.gov.cn" target="_blank"
        >ICP备案号：粤ICP备09038892号</a
      >
    </div>
  </div>
</template>

<script>
import { Message } from "element-ui";
import Cookies from "js-cookie";
import axios from "axios";
import md5 from "js-md5";
import { mapActions, mapState } from "vuex";
import { login_url, getVerifyCode, checkVerifyCode } from "../api/url.js";
import systemConfig from "@/utils/globalVal.js";
import { eventBus } from "../helper/EventBus.js";
import CryptoJS from "crypto-js";
import JSEncrypt from 'jsencrypt';
const PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEApd3e68fLMXI8V1huLJ/t
vlD5JvgssTMQguokwRd3Lr/RQ++zBQusFIymeZ8H87PciEvnHSCJBhmUnzhkiMKF
SrewLVLvWHj2WYzBDgh6VpPGsfdVYq0uoxciyR782RQdyD5mmlzcQ4WQdofzUDSW
qBC3XwFYo5qTM8fUU2Q1XMU2zA8VDLj/QC1A7XndohYEjag7yoOfi2z8KVQ3XCzH
5DLkd+UnJvAi8lKTqhnmCwUyQhFO245ZzM1gIRGyAOh2sf92BspDiWa0WUY+i15c
8v1jcYxnmb1qLVw4r3XVXS1cCGQ9/SKe3AM8ObuUC2SU02uQfFEhobZMhzBVO1K9
qQIDAQAB
-----END PUBLIC KEY-----`;
const AES_KEY = "your-secret-key"; // 默认示例密钥，生产环境请更换
export default {
  name: "login",
  data() {
    return {
      systemConfig: {},
      loginForm: {
        username: "",
        password: "",
        captcha: "",
      },
      msg: {
        error: "用户名或密码错误",
        empty: "用户名或密码为空",
      },
      isFocus: true,
      isFocuspsd: false,
      applicationType: "outside",
      captchaImg: "",
      captchaId: "", // 图形验证码ID
    };
  },
  created: function () {
    document.getElementById("appLoading").style.display = "none";
    this.systemConfig = systemConfig;
    // 删除记住密码功能相关逻辑
  },
  mounted() {
    this.setSubmenuList([]);
    this.setMainMenuMovePlace({ place: 172 });
    this.setCurrentMovePlace({ place: 0 });
    // 登录前清除强制修改密码标记
    if (localStorage.getItem("forceChangePassword") === "1") {
      localStorage.removeItem("forceChangePassword");
    }
    if (localStorage.getItem("userId")) {
      localStorage.removeItem("userId");
    }
    this.getCaptcha();
  },
  computed: {},
  methods: {
    ...mapActions(["getAdminData"]),
    ...mapActions("menu", [
      "setSubmenuList",
      "setMainMenuMovePlace",
      "setCurrentMovePlace",
    ]),
    async getCaptcha() {
      const res = await axios.get(getVerifyCode(), {
        responseType: "blob"
      });
      // 读取 header 中的 X-Captcha-Key
      const captchaKey = res.headers['x-captcha-key'] || res.headers['X-Captcha-Key'];
      if (captchaKey) {
        this.captchaId = captchaKey;
      }
      this.captchaImg = URL.createObjectURL(res.data);
    },
    refreshCaptcha() {
      this.getCaptcha();
    },
    async checkCaptcha() {
      const formData = new FormData();
      formData.append('captchaKey', this.captchaId); // 注意K大写
      formData.append('captcha', this.loginForm.captcha);
      const res = await axios.post(
        checkVerifyCode(),
        formData
      );
      return res.data;
    },
    async login() {
      var _this = this;
      function checkPasswordRule(password) {
        // 长度至少8位
        if (password.length < 8) return false;
        // 包含大写字母
        if (!/[A-Z]/.test(password)) return false;
        // 包含数字
        if (!/[0-9]/.test(password)) return false;
        // 包含特殊符号
        if (!/[^A-Za-z0-9]/.test(password)) return false;
        return true;
      }
      if (this.loginForm.username == "" || this.loginForm.password == "") {
        Message({
          message: this.msg.empty,
          type: "warning",
        });
        return;
      }
      if (!this.loginForm.captcha) {
        Message({
          message: "请输入验证码",
          type: "warning",
        });
        return;
      }
      // 先校验验证码
      const captchaResult = await this.checkCaptcha();
      if (captchaResult.status!=200) {
        Message({
          message: captchaResult.msg || "验证码错误",
          type: "warning",
        });
        this.getCaptcha();
        return;
      }
      Cookies.set("Authorization", "", { path: "" });
      Cookies.set("userName", "", { path: "" });
      // 用 jsencrypt 加密用户名和密码
      const encrypt = new JSEncrypt();
      encrypt.setPublicKey(PUBLIC_KEY);
      // const encryptedUsername = encrypt.encrypt(this.loginForm.username);
      // const encryptedPassword = encrypt.encrypt(this.loginForm.password);
      this.$post(login_url(), {
        grant_type: "password",
        username: this.loginForm.username,
        password: this.loginForm.password,
        captcha: this.loginForm.captcha,
        captchaId: this.captchaId,
      })
        .then((data) => {
          if (data.access_token === "" || data.access_token === undefined) {
            this.getCaptcha();
            Message({
              message: _this.msg.error,
              type: "warning",
            });
          } else {
            Cookies.set("Authorization", data.access_token, { path: "" });
            Cookies.set("userName", data.userName, { path: "" });
            eventBus.$emit("user-event", data.userName);
            localStorage.setItem("userId", data.userId);
            if (!checkPasswordRule(this.loginForm.password)) {
              console.warn("密码不符合规则，强制修改密码");
              localStorage.setItem("forceChangePassword", "1");
            }
            _this.$router.push("/main/home");
          }
        })
        .catch(function (error) {
          this.getCaptcha();
          console.log(error);
        });
    },
    logout: function () {
      var _this = this;
      axios({
        method: "delete",
        url: login_url() + "?access_token=" + Cookies.get("Authorization"),
        headers: { Authorization: "Basic dnVlOnZ1ZQ==" },
      })
        .then(function (response) {
          var data = response.data;
          if (data.status == 200) {
            Cookies.remove("Authorization", { path: "" });
            localStorage.removeItem("forceChangePassword");
            localStorage.removeItem("userId");
            _this.$router.push("/");
          }
        })
        .catch(function (error) {
          // console.log(error);
        });
    },
    async submitForm() {
      try {
        if (Cookies.get("Authorization")) {
          await this.logout();
        }
        this.login();
      } catch (error) {
        console.log(error);
      }
    },

    handleKeydown: function (ev) {
      // alert('你按回车键了');
      if (ev.keyCode == 13) {
        this.submitForm();
      }
    },
  },
  watch: {},
};
</script>

<style scoped>
@import "../assets/css/login.css";
.loginbody {
  background: #eee;
  background-size: 100% 100%;
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
}

.loginbody-bg {
  /* background-color:#152C72; */
  background-color: #002f55;
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: space-between;
  padding: 0 10%;
  align-items: center;
}
.loginbox {
  display: flex;
  align-items: center;
  height: 400px;
  background: white;
  width: 500px;
  border-radius: 10px;
  justify-content: center;
  box-shadow: 0 0 10px #666;
}

.input ul .logins {
  padding: 6px 2px 6px 46px;
  border: 1px solid #152c72;
  border-radius: 8px;
  background: url("../assets/images/username2.png") no-repeat 14px center;
  background-size: 20px 20px;
}
/* 验证码行去大边框，input有小边框 */
li.logins.captcha-line {
  border: none !important;
  background: none !important;
  padding: 0 !important;
  background-image: none !important;
}
.input ul .logins.captcha-line input.login-captcha {
  border: 1px solid #bdbdbd !important;
  border-radius: 6px;
  background: #fff;
  color: #152c72;
  font-size: 16px;
  padding-left: 10px;
  box-sizing: border-box;
  outline: none;
  height: 32px;
  line-height: 32px;
  width: 290px;
}
.input ul .logins input {
  width: 290px;
  height: 30px;
  padding-left: 10px;
  background: none;
  color: #152c72;
}
.input ul .loginpsd {
  margin-bottom: 4px;
  background: url("../assets/images/psd2.png") no-repeat 14px center;
  background-size: 20px 20px;
}

.reset .backpsd {
  padding-left: 20px;
  height: 20px;
  line-height: 20px;
}
.reset .register a {
  color: #589ffe;
}
.form_tip {
  height: 20px;
  line-height: 20px;
  color: #d00;
}

.input ul li .btnlogin {
  width: 80%;
  height: 44px;
  font-size: 16px;
  border-radius: 0px;
  background-color: #002f55;
  color: white;
}
.input ul li .btnlogin:hover {
  background: #034e8b;
}
.loginbm {
  height: 50px;
  line-height: 50px;
  text-align: center;

  position: absolute;
  bottom: 0;
  width: 100%;
  color: #002f55;
}

.loginbm a {
  font-weight: bold;
  color: #002f55;
}

.loginbm a:hover {
  color: #fff;
}
.input h1 {
  height: 88px;
  width: 360px;
  text-align: center;
  line-height: 88px;
}

.input h1 img {
  width: 144px;
  margin: 0 108px;
  display: inline-block;
  text-align: center;
  opacity: 1;
}

.logo-name {
  font-size: 32px;
  color: white;
  background: url("../assets/images/logo_bg.png") no-repeat 14px center;
  background-size: 100px 100px;
  padding-left: 110px;
  opacity: 0.6;
  height: 100px;
}
.logo-name p:last-child {
  font-size: 30px;
}

/* 删除记住密码相关样式 */
.footer {
  position: fixed;
  bottom: 0;
}
.footer .content {
  background: none !important;
  border-top: none !important;
}
.applicationType {
  padding: 20px;
  display: flex;
  justify-content: space-between;
}
.applicationType span {
  display: inline-block;
  font-size: 18px;
  border: #002f55 1px solid;
  width: 40%;
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  color: white;
  text-align: center;
  cursor: pointer;
  color: #002f55;
}
.applicationType span:first-child {
  margin-right: 20px;
}
.outside {
  background-color: #002f55 !important;
  color: white !important;
}
.beian {
  position: fixed;
  width: 100%;
  bottom: 0;
  left: 0;
  text-align: center;
  margin-bottom: 10px;
}
#username {
  border: none !important;
  box-shadow: none !important;
}
/* 在<style scoped>末尾添加验证码输入框样式，去掉外框和图标 */
#login .login-captcha {
  border: none !important;
  box-shadow: none !important;
  background: none !important;
  padding-left: 10px !important;
}
.input ul .logins input.login-captcha {
  border: none !important;
  box-shadow: none !important;
  background: none !important;
  background-image: none !important;
  padding-left: 10px !important;
  color: #152c72 !important;
  height: 32px !important;
  line-height: 32px !important;
  vertical-align: middle;
  width: 290px !important;
}
.input ul li[style*="text-align: center"] {
  margin-top: 32px;
}
</style>